export const HOTEL_ID = 7225
export const OMNIBESS_API = 'https://book.omnibees.com/hotelresults'
export const MINIMUM_CHILD_AGE = 10
export const MINIMUM_RESERVATION_DAYS = 1



// WEBPACK FOOTER //
// ./src/store/final.js